import {integritySpac} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadIntegritySpac(selection: any) {
  return useLoad(integritySpac, 'revision', {values: selection});
}

export default useLoadIntegritySpac;
